import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_LARGER, Z_INDEX_PRIVATE_LAYOUT_NAV_BAR } from '~/Constants/UI.constants';

export const PrivateLayoutTitleStyles = makeStyles(
  (theme) => ({
    titleContainer: {
      [theme.breakpoints.up('md')]: {
        padding: '40px 0',
      },
      [theme.breakpoints.down('md')]: {
        padding: '24px 16px',
      },
    },
    navbarTitle: {
      [theme.breakpoints.down('md')]: {
        padding: 0,
        position: 'fixed',
        top: 0,
        zIndex: Z_INDEX_PRIVATE_LAYOUT_NAV_BAR,
      },
    },
    titleWrapper: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    title: {
      fontSize: FONT_SIZE_LARGER,
      fontWeight: 'bold',
      lineHeight: '34px',
      flex: '1 0 50%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    desktopBackButton: {
      marginBottom: theme.spacing(1),
    },
    optionsMenuItem: {
      minWidth: 128,
    },
  }),
  { name: 'PrivateLayoutTitle' },
);
